import { useQuery } from '@tanstack/react-query'

const User = ({ userId }) => {

  const { data, isLoading } = useQuery(
    ['username', `username-${userId}`],
    () => getUsername(userId)
  )

  const getUsername = async (id) => {
    if (id !== undefined) {
      const projUsers = await Weaver.User.listProjectUsers()
      const user = projUsers.find((user) => user.id() === userId)
      return `${user.firstname} ${user.lastname}`
    } else {
      return " "
    }
  }

  if (isLoading) {
    return null
  } else {
    return (
      <div>
        { data }
      </div>
    )
  }
}

export default User
